import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Button, Flex, Text } from "@chakra-ui/react";

// Replaces React Router's default error page, which catches errors before Sentry sees them
export default function ErrorPage() {
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <Flex
      height="100%"
      direction="column"
      align="center"
      justify="center"
      gap={4}
      padding={4}
      textAlign="center"
    >
      <Text fontSize="xl">Une erreur est survenue.</Text>
      <Button onClick={() => window.location.reload()}>
        Recharger la page
      </Button>
    </Flex>
  );
}
